module.exports = __webpack_public_path__ + "img/buff_combo.5da39b5c.png";